// extracted by mini-css-extract-plugin
export var introContain = "introContainer-module--introContain--vz-yy";